import Vue from "vue";
import VueRouter from "vue-router";
import NProgress from "nprogress";
import 'nprogress/nprogress.css';

import api from "../utils/api";
import auth from "../utils/auth";
import func from "../utils/func";
import enums from "../utils/enums";
import store from "../store/index";

import Login from "../pages/Login";
import Index from "../pages/Index";

import Album from "../pages/index/Album";
import UCenter from "../pages/index/UCenter";

NProgress.configure({showSpinner: false});

Vue.use(VueRouter);

let routes = [
    {
        path: "/",
        name: "Index",
        component: Index,
        meta: {title: "EFOTO"},
        redirect: {name: "Album"},
        children: [
            {
                name: "Album",
                path: "album",
                component: Album,
                meta: {title: "我的相册", icon: "folder"},
                redirect: {name: "Album.Default"},
                children: require("./album").default
            },
            {
                name: "UCenter",
                path: "ucenter",
                meta: {title: "个人信息", icon: "user"},
                component: UCenter,
                redirect: {name: "UCenter.Default"},
                children: require("./ucenter").default
            },
        ]
    },
    {
        name: "Login",
        path: "/login",
        component: Login,
    },
];

let router = new VueRouter({
    routes: routes,
    mode: process.env.IS_ELECTRON ? "hash" : "history"
});

router.beforeEach(async (to, from, next) => {
    NProgress.start();
    let ticket = to.query.ticket;
    if (func.stringStrict(ticket)) {
        await api.v1.auth.loginSubmit({
            ticket_id: ticket,
            platform: enums.Platform
        });
    }
    let guest = await auth.isGuest();
    store.commit("layout/refresh", to);
    (to.name === "Login")
        ? (guest ? next() : next({name: "Index"}))
        : (guest ? next({name: "Login", query: {refer: to.name}}) : next());
    NProgress.done();
});

export default router;
